import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Layout } from "../../layouts/Layout";
import DataGajiKaryawan from "../../componen/gajiKaryawan/DataGajiKaryawan";

export const DataGajiKaryawanPages = () => {
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate("/", { replace: true });
  }, [isError, navigate]);

  return <DataGajiKaryawan />;
};
